import reportsConfig from '~/constants/data-reports/nickel'

const nickelData = {
  hero: reportsConfig.hero,
  descriptions: [
    'The future of nickel needs an in depth understanding of the lithium ion battery industry and the rapid development of cathode materials.',
    'Nickel is set to be a major benefactor of the energy storage revolution and Benchmark is bringing nickel supply analysis into a new era.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719416656/assets/market/nickel/nickel-1_ge67qk.jpg',
  brochureFile: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Nickel-Price-Assessment-Methodology.pdf',
    EnvKey: 'nickelPriceAssessmentsMethodologyId',
  },
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  indexTab: true,
  customisationToolTab: true,
  requiredFilters: ['categories', 'shippingRoutes', 'purities', 'priceTypes'],
}

export default nickelData
